<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-grid">
        <div>
          <div class="logo">
            <img class="logo-img" :src="logoImg" alt="动态时序科技" />
          </div>
          <p>专注商业数据监控及调用服务，让数据成为企业最可靠的决策伙伴。</p>
        </div>

        <div>
          <h4>导航</h4>
          <ul>
            <li><router-link to="/">首页</router-link></li>
            <li><router-link to="/aboutUs">关于我们</router-link></li>
            <li><router-link to="/api">数据产品</router-link></li>
            <li><router-link to="/consulting">技术服务</router-link></li>
            <li><router-link to="/contact">联系我们</router-link></li>
          </ul>
        </div>

        <div>
          <h4>产品</h4>
          <ul>
            <li><router-link to="/api">数据产品 · API 接口</router-link></li>
            <li><router-link to="/consulting">数据技术服务</router-link></li>
            <li><router-link to="/charge">充值中心</router-link></li>
            <li><router-link to="/apiTest">在线接口测试</router-link></li>
          </ul>
        </div>

        <div>
          <h4>联系方式</h4>
          <ul>
            <li>service@workatdata.com</li>
            <li>北京市海淀区北三环西路32号 恒润国际大厦</li>
          </ul>
        </div>
      </div>

      <div class="footer-bottom">
        <span>© 2026 动态时序科技有限公司 版权所有</span>
        <span class="footer-legal">
          <router-link to="/aboutUs/case2">用户协议</router-link>
          <router-link to="/aboutUs/case3">隐私政策</router-link>
          <router-link to="/aboutUs/case4">认证服务协议</router-link>
        </span>
        <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener">京ICP备2022012793号-1</a>
      </div>
    </div>
  </footer>
</template>

<script>
/* 全站页脚
   结构移植自 website-handoff（深色四列 + footer-bottom），
   备案号沿用本项目真实备案信息（京ICP备2022012793号-1，跳转 beian.miit.gov.cn）。
   footer-legal 与 handoff 对齐：「用户协议 / 隐私政策 / 认证服务协议」三个入口与法务页同存在于左侧文档导航。
  「产品」列对齐 handoff 定稿；原「API 数据平台 ↗」外链已按 handoff「线上平台外链入口全部站内化」
  替换为站内入口（数据技术服务 / 在线接口测试），全站不再有任何指向该首页的链接。 */
export default {
  name: 'SiteFooter',
  data() {
    return {
      // 深色页脚用 logo 的白色变体：蓝色标识方块保持品牌蓝、字标转白
      // （直接换白色变体，不再用 CSS 滤镜整体转白，避免蓝色背景被一起滤掉）
      logoImg: require('../assets/logo-inverse.png')
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/SiteFooter.vue